import { dataHooks } from '@wix/data-hooks';

export const assistantChatMessageDataHooks = dataHooks<{
  chatMessage: {};
}>('assistant-chat-widget');
